import { action, runInAction, observable } from 'mobx';
import { ErrorInterface } from 'modules/core/api/globalApi';
import seoController from './controller';
import {
  ServiceRegionItemInterface,
  ServiceRegionCreateRequestInterface,
  ServiceRegionUpdateRequestInterface,
} from '../api/servicesApi';

export interface ServiceStore {
  serviceRegions: ServiceRegionItemInterface[],
  serviceRegionsByServiceId: number,
  currentServiceRegion: ServiceRegionItemInterface,

  error: ErrorInterface,
}

const initialValues: ServiceStore = {
  serviceRegions: [],
  serviceRegionsByServiceId: null,
  currentServiceRegion: null,

  error: null,
};

export const serviceStore = observable(initialValues);

export const serviceActions = {

  async getServiceRegions(serviceId:number) {
    serviceActions.clearError();
    runInAction(() => {
      serviceStore.serviceRegionsByServiceId = serviceId;
    });
    const response = await seoController.getServiceRegions(serviceId);
    if (response.errorData) {
      serviceStore.serviceRegionsByServiceId = null;
    }
    serviceActions.handleError(response);
    runInAction(() => {
      serviceStore.serviceRegions = response.data;
    });
  },

  createServiceRegion: async (request: ServiceRegionCreateRequestInterface): Promise<void> => {
    serviceActions.clearError();
    const response = await seoController.createServiceRegion(request);
    serviceActions.handleError(response);
  },

  updateServiceRegion: async (request: ServiceRegionUpdateRequestInterface): Promise<void> => {
    serviceActions.clearError();
    const response = await seoController.updateServiceRegion(request);
    serviceActions.handleError(response);
  },

  deleteServiceRegion: async (id: string): Promise<void> => {
    serviceActions.clearError();
    const response = await seoController.deleteServiceRegion(id);
    serviceActions.handleError(response);
  },

  handleError: action((response, id:string = null) => {
    if (response.errorData) {
      const { errorData } = response;
      serviceStore.error = {
        message: errorData?.message,
        errorCode: errorData?.errorCode,
        timestamp: errorData?.timestamp,
        status: response?.status,
        connectError: response?.connectError,
        isError: response?.error,
        id,
      };
      throw errorData;
    }
  }),

  handleErrorWithoutThrow: action((response) => {
    if (response.errorData) {
      const { errorData } = response;
      serviceStore.error = errorData;
    }
  }),

  clearError: action(() => {
    serviceStore.error = null;
  }),

  clearServiceRegions: async () => {
    try {
      runInAction(() => {
        serviceStore.serviceRegions = [];
        serviceStore.serviceRegionsByServiceId = null;
      });
    } catch (err) {
      serviceActions.handleError(err);
    }
  },

  setCurrentServiceRegion: async (data: ServiceRegionItemInterface): Promise<void> => {
    serviceActions.clearError();
    runInAction(() => {
      serviceStore.currentServiceRegion = data;
    });
  },

  clearCurrentServiceRegion: async (): Promise<void> => {
    serviceActions.clearError();
    runInAction(() => {
      serviceStore.currentServiceRegion = null;
    });
  },

};
